import { Component, OnInit, ViewChild } from '@angular/core';
import { ImageTipService } from '../../../service/api/builk/image-tip.service';
import { ImageTipItemModel, ImageTipListQueryModel } from '../../../model/builk/image-tip/image-tip.model';
import { CreateNewCouponComponent } from '../coupon-setting/modals/create-new-coupon/create-new-coupon.component';

@Component({
  selector: 'app-image-tip-setting',
  templateUrl: './image-tip-setting.component.html',
  styleUrls: ['./image-tip-setting.component.scss']
})
export class ImageTipSettingComponent implements OnInit {
  @ViewChild("createImageTip") createImageTip: CreateNewCouponComponent;

  // boolean
  isLoading: boolean = false;

  // model
  queryModel: ImageTipListQueryModel = new ImageTipListQueryModel();

  // array
  imageTipList: Array<ImageTipItemModel> = new Array<ImageTipItemModel>();

  constructor(
    private imageTipService: ImageTipService
  ) { }

  ngOnInit() {
    this.initData();
    this.getImageTips();
  }

  initData() {
    //TODO
    this.queryModel.pageNumber = 1;
    this.queryModel.pageSize = 15;
    this.queryModel.sortByDesc = true;
    this.queryModel.sortColumn = '';
    this.queryModel.textSearch = '';
  }

  getImageTips() {
    this.isLoading = true;
    this.imageTipService.getImageTips(this.queryModel).subscribe(res => {
      console.log(res)
      this.imageTipList = res.itemList;
      this.isLoading = false;
    });
  }

  openCreateImageTipModal () {
    this.createImageTip.openModal();
  }

  isSaved(val: boolean) {
    if (val) {
      this.getImageTips();
    }
  }

}
